import React from 'react';
import { Phone } from 'lucide-react';
import { motion } from 'framer-motion';
export function Header() {
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className="fixed top-0 left-0 right-0 z-50 glass-effect" data-id="element-59">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-60">
        <div className="flex items-center gap-3" data-id="element-61">
          <div className="w-10 h-10 rounded-xl bg-slate-50 border border-slate-100 flex items-center justify-center" data-id="element-62">
            <span className="text-slate-900 font-bold text-xl leading-none" data-id="element-63">
              В
            </span>
          </div>
          <div className="flex flex-col" data-id="element-64">
            <span className="font-bold text-lg tracking-tight leading-none text-slate-900" data-id="element-65">
              Військовий Адвокат
            </span>
            <span className="text-[10px] font-semibold uppercase tracking-widest mt-1 text-slate-400" data-id="element-66">
              Юридична практика
            </span>
          </div>
        </div>

        <a href="tel:+380687870587" className="flex items-center gap-2 px-5 py-2.5 bg-slate-900 hover:bg-slate-800 text-white rounded-full transition-all duration-300 text-sm font-semibold shadow-sm hover:shadow-md" data-id="element-67">
          <Phone className="w-4 h-4" data-id="element-68" />
          <span className="hidden sm:inline" data-id="element-69">068 787 0587</span>
        </a>
      </div>
    </motion.header>;
}